var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { keyframes } from 'styled-components';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { colors } from '../../../defaultTheme';
const SpinnerAnimation = keyframes `
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const LoadingWrapper = styled.div `
  svg,
  png,
  jpg {
    animation: ${SpinnerAnimation} 1s linear infinite;
  }
`;
const SpinnerLoader = (_a) => {
    var { color = colors.grey, size, icon = (_jsx(FontAwesomeIcon, { icon: faSpinner, title: "Content Loading", color: color, size: size })), className, ariaLabel = 'Content Loading' } = _a, props = __rest(_a, ["color", "size", "icon", "className", "ariaLabel"]);
    return (_jsx(LoadingWrapper, Object.assign({ className: className }, props, { "aria-label": ariaLabel }, { children: icon })));
};
export default SpinnerLoader;
//# sourceMappingURL=Spinner.js.map